import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useClientUiSettings } from '../../../hooks/useClientUiSettings';

/**
 * Small "(i)" tooltip rendered next to a dashboard widget title.
 *
 * Copy is sourced from PlatformSettings.clientUi.dashboardWidgetCopy[id].
 * If no copy is seeded for the given widget id, this component renders nothing —
 * tenants without seeded copy get the same UI they had before (T1-4 in the
 * Meeting 3 plan).
 */
const WidgetInfoTooltip = ({ id }) => {
  const { dashboardWidgetCopy = {} } = useClientUiSettings();
  const copy = dashboardWidgetCopy?.[id];
  if (!copy) return null;

  return (
    <Tooltip title={copy} arrow>
      <IconButton
        size="small"
        aria-label="What this is"
        sx={{ ml: 0.5, opacity: 0.55, padding: '2px' }}
      >
        <InfoOutlinedIcon sx={{ fontSize: '0.95rem' }} />
      </IconButton>
    </Tooltip>
  );
};

export default WidgetInfoTooltip;
